import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IAdGroup, IAdGroupUpdate, IError } from '@unfoldrtech/portal-mic'
import { coreAPI } from '../services/coreAPI'
import { generateCorrelationId } from '../utils/helpers'

type TPatchAdGroupMutationResult = UseMutationResult<
  AxiosResponse<IAdGroup>,
  AxiosError<IError>,
  {
    payload: IAdGroupUpdate
  }
>

export default function usePatchAdGroup({
  advertiserId,
  retailerId,
  adGroupId,
}: {
  advertiserId: number
  retailerId: number
  adGroupId: number
}) {
  return useMutation([`patchAdGroup_${adGroupId}`], (params) => {
    return coreAPI
      .advertiserCampaigns()
      .patchAdGroup(
        advertiserId,
        retailerId,
        adGroupId,
        generateCorrelationId(),
        params.payload
      )
  }) as TPatchAdGroupMutationResult
}
